




















































import { Question } from '@/resource/question/question.model';
import { Component, Prop, Vue } from 'vue-property-decorator';
import PublicQuestionContainer from '@/components/public-questions/PublicQuestionContainer.vue';
import { User } from '@/resource/user/user.model';
import {
  BuildQuestion,
  generatePDF,
} from '@/utils/add-question/add-question-util';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';

@Component({
  components: {
    PublicQuestionContainer,
    BeatLoader,
  },
})
export default class AddQuestionPreview extends Vue {
  @Prop({ required: true })
  question!: Question;

  @Prop({ default: false })
  isSubjective!: boolean;

  @Prop()
  questionId!: number;

  @Prop()
  buildQuestion!: BuildQuestion;

  isLoading = false;

  getName(user: User) {
    if (user) {
      return `${user.firstName} ${user.lastName}`;
    } else {
      return 'N/A';
    }
  }

  get showDetails() {
    return this.question.id ? true : false;
  }

  async createPdf() {
    if (this.isLoading) return;

    this.isLoading = true;

    const pdfGenerated = await generatePDF({
      questionId: this.questionId,
      isSubjective: this.isSubjective,
      buildQuestion: this.buildQuestion,
    });

    if (pdfGenerated) {
      const blob = new Blob([pdfGenerated], {
        type: 'application/pdf',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'PREVIEW QUESTION');
      document.body.appendChild(link);
      link.click();
    }

    this.isLoading = false;
  }
}
